export { default } from './Stories.component';
